const getStudentSeniority = (user) => {
  const highestDegree = user.general_info.highest_degree;
  const status = user.general_info.status;
  const yearsHeld = user.general_info.held_position_time;

  switch(highestDegree){
    case 'no_degree':
      switch(status){
        case 'undergraduate_student':
          return 'junior'
        case 'industry':
          switch(yearsHeld){
            case 'between_four_and_five_years':
              return 'intermediate'
            case 'more_than_six_years':
              return 'intermediate'
            default:
              return 'junior'
          }
        case 'other':
          return 'undefined'
        default:
          break;
      }
      break;
    case 'secondary_school':
      switch(status){
        case 'undergraduate_student':
          return 'junior'
        case 'industry':
          switch(yearsHeld){
            case 'between_four_and_five_years':
              return 'intermediate'
            case 'more_than_six_years':
              return 'intermediate'
            default:
              return 'junior'
          }
        case 'other':
           return 'undefined'
        default:
          break;
      }
      break;
    case 'undergraduate_degree':
      switch(status){
        case 'masters_student':
          switch(yearsHeld){
            case 'zero_years':
              return 'junior'
            default:
              return 'intermediate'
            }
        case 'phd_student':
         switch(yearsHeld){
            case 'between_four_and_five_years':
              return 'senior'
            case 'more_than_six_years':
              return 'senior'
            default:
              return 'intermediate'
            }
        case 'lecturer_professor_faculty':
         switch(yearsHeld){
            case 'zero_years':
              return 'junior'
            case 'between_four_and_five_years':
              return 'senior'
            case 'more_than_six_years':
              return 'senior'
            default:
              return 'intermediate'
            }
        case 'industry':
         switch(yearsHeld){
            case 'zero_years':
              return 'junior'
            case 'more_than_six_years':
              return 'senior'
            default:
              return 'intermediate'
            }
        case 'other':
          return 'undefined'
        default:
          break;
      }
      break;
    case 'masters_degree':
      switch(status){
        case 'phd_student':
          switch(yearsHeld){
            case 'three_years':
              return 'senior'
            case 'between_four_and_five_years':
              return 'senior'
            case 'more_than_six_years':
              return 'senior'
            // less than 3 years
            default:
              return 'intermediate'
            }
        case 'lecturer_professor_faculty':
          switch(yearsHeld){
            case 'zero_years':
              return 'intermediate'
            case 'one_year':
              return 'intermediate'
            // 2 years or more
            default:
              return 'senior'
            }
        case 'industry':
          switch(yearsHeld){
            case 'zero_years':
              return 'intermediate'
            case 'one_year':
              return 'intermediate'
            // 2 years or more
            default:
              return 'senior'
            }
        case 'other':
          return 'undefined'
        default:
          break;
      }
      break;
    case 'doctoral_degree':
      return 'senior'
    // other case
    default:
      switch(status){
        case 'undergraduate_student':
          return 'junior'
        default:
          return 'undefined'
      }
  }
}

export { getStudentSeniority }
